export default __webpack_public_path__ + "static/media/PAKMI.f9fac377.png";